import React from "react";

export default function Checkout() {
  return <h1>hello from checkout page</h1>;
}
